import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Input from "../components/Input";
import Keypad from "../components/Keypad";
import NextButton from "../components/NextButton";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import { navigateToNext, NavigateToNext } from "../store/actions";
import { IStrings } from "../store/reducers/strings";

interface IZipDispatchProps {
  onNavigateToNext: NavigateToNext;
}
interface IZipStateProps {
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
}
type ZipProps = RouteComponentProps & IZipDispatchProps & IZipStateProps;
interface IZipState {
  sending: boolean;
  zip: string;
  zipIsValid: boolean;
}
type ZipState = IZipState;

const ZipContainer = styled(Container)``;
const ZipInput = styled(Input)`
  font-family: monospace;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  width: 14rem;
  margin: 0;
  font-size: 1.5rem;
  border: 2px solid black;
  border-right-width: 1px;
  border-radius: 12px 0 0 12px;
  padding-left: 0.5rem;
`;
const BackArrow = () => (
  <svg width="2rem" height="2rem" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" />
  </svg>
);

const BackButton = styled(Button)`
  width: 4rem;
  height: 4rem;
  padding: 0.9rem;
`;

class Zip extends React.Component<ZipProps, ZipState> {
  public state: ZipState = {
    sending: false,
    zip: "",
    zipIsValid: false,
  };

  public componentDidMount() {
    const {
      onNavigateToNext,
      businessId,
      siteId,
      user: { zip, mobile },
    } = this.props;

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const from = params.get("from");

    const tearApartJoinSlc = (siteId && siteId === 'FDYHKAMSiYNCuXumk5Iv' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartJoinOgden = (siteId && siteId === 'TMrSaHl6j451pEWxY7nu' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartCheckinSlc = (siteId && siteId === 'kv9ciglhFsJBh9YyV2sd' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartCheckinOgden = (siteId && siteId === '6vVH4qpzsVxjmROhMDmh' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleSlc = (siteId && siteId === '17VBJyeH2crmqQC2OSxx' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleOgden = (siteId && siteId === '1YYyeZ1YXjGyc6Z6vwRt' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;


    const tearApartAll = tearApartJoinSlc || tearApartJoinOgden || tearApartCheckinSlc || tearApartCheckinOgden || tearApartVehicleSlc || tearApartVehicleOgden;

    const skipZip = ((siteId && siteId === 'bsZLKWJMaoIwztWi0gMg' && businessId && businessId === 'WpJtEW5saD7d4bRutXXb') || (siteId && siteId === 'JGOUaPdjCw7AxY1auyYy' && businessId && businessId === 'SmhXMTflviq60mlf221Z')) ? true : false;

    // if ((zip && from !== "thanks")) {
    if ((zip && from !== "thanks") || (mobile === "6028181729" && skipZip) || (mobile === "6028181729" && tearApartAll)) {
      onNavigateToNext();
    }
  }

  public keypadValidator = (zip: string, value: string) => {
    let newZip;

    if (zip.length < 5 && value.match(/\d/g)) {
      newZip = zip + value;

      if (newZip.length === 5) {
        this.setState({ zipIsValid: true });
      }

      return newZip;
    }

    if (value === "clear") {
      this.setState({ zipIsValid: false });

      return "";
    }

    if (value === "backspace") {
      newZip = zip.slice(0, -1);

      this.setState({ zipIsValid: false });

      return newZip;
    }

    return zip;
  };

  public handleKeypadButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;

    const zip = this.keypadValidator(this.state.zip, value);

    this.setState({ zip });
  };

  public handleInput = ({ currentTarget: { value } }: React.FormEvent<HTMLInputElement>) =>
    this.setState({ zip: value });

  public render() {
    const {
      languageStrings: strings,
      routes: {
        zip: { optional },
      },
      theme: { colors },
      site: {
        kioskUiBackgroundColor,
        kioskUiTitleTextColor,
        kioskUiButtonPrimaryColor,
        kioskUiButtonErrorColor,
        kioskUiButtonSuccessColor,
      },
      site,
      user,
    } = this.props;
    const { zip, zipIsValid, sending } = this.state;
    const zipPlaceholder = "xxxxx";

    return (
      <ErrorBoundary>
        <ZipContainer style={{ background: kioskUiBackgroundColor }}>
          <Row align="center" justify="center">
            <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary}>{strings.zipHeader}</Title>
          </Row>
          <Column align="center" justify="space-around">
            <Row>
              <ZipInput type="tel" onChange={this.handleInput} placeholder={zipPlaceholder} value={zip} />
              <BackButton
                bg={kioskUiButtonPrimaryColor ? kioskUiButtonPrimaryColor : colors.primary}
                borderRadius="right"
                disabled={sending}
                margin="0"
                onClick={this.handleKeypadButton}
                size="2rem"
                value="backspace"
              >
                <BackArrow />
              </BackButton>
            </Row>
            <Keypad
              colors={colors}
              disabled={sending}
              isUppercase={false}
              onHandleKeypadClick={this.handleKeypadButton}
              type="numbers"
              site={site}
            />
          </Column>
          <Row align="center" justify="center">
            <ResetButton site={site} />
            {optional && (
              <NextButton
                bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                disabled={false}
                label={"No Thanks"}
                name={null}
                value={null}
              />
            )}
            <NextButton
              bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
              disabled={!zipIsValid}
              name="zip"
              value={zip}
            >
              {strings.addZip}
            </NextButton>
          </Row>
        </ZipContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({ router: { languageStrings }, theme, user }) => ({
  languageStrings,
  theme,
  user,
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
};

export default connect<IZipStateProps, IZipDispatchProps>(mapStateToProps, mapDispatchToProps)(Zip);



// WEBPACK FOOTER //
// ./src/views/Zip.tsx